<button mat-icon-button
        aria-label="Current task list" title="Current task list"
        routerLink="/current">
  <mat-icon>checklist</mat-icon>
</button>

<div class="create-task-form">
  <h2>Creating a Task</h2>

  <app-edit-task-form [task]="newTask"></app-edit-task-form>
</div>

<button (click)="onSave()">Create</button>
